import { useLightMode } from '@/hooks/useLightMode'

import { Box, Menu, MenuButton, MenuList, Tooltip } from '@chakra-ui/react'

import { DarkProvider, GuardsIcon, UtilityButton } from '@hivewatch/dark'

import { MenuSelectItem } from '@/components/ui'

import { getTabColors } from '../../shared/utils/helpers'

export interface GuardActionTabIProps {
  tooltipText: string
  onDispatchClick: () => void
  onRadioClick: () => void
  isDispatchEnabled: boolean
  isRadioEnabled: boolean
  isSelected: boolean
}

export const GuardActionTab = ({
  onDispatchClick,
  onRadioClick,
  tooltipText,
  isDispatchEnabled,
  isRadioEnabled,
  isSelected,
}: GuardActionTabIProps) => {
  const colorScheme = useLightMode()
  const { hoverBgColor } = getTabColors(isSelected)

  return (
    <Menu closeOnBlur={true} gutter={0} isLazy={true} matchWidth={false}>
      <Tooltip
        bg={hoverBgColor}
        color='white'
        hasArrow
        isDisabled={isSelected}
        label={tooltipText}
        mt='5px'
        openDelay={250}
        p='10px'
      >
        <Box as='span' display='inline-block'>
          <DarkProvider>
            <MenuButton
              as={UtilityButton}
              colorScheme={colorScheme}
              icon={<GuardsIcon size={18} />}
              isSelected={isSelected}
              label={tooltipText}
            />
          </DarkProvider>
        </Box>
      </Tooltip>
      <MenuList p={0}>
        <MenuSelectItem
          isDisabled={!isDispatchEnabled}
          label='Dispatch Guards'
          onClick={onDispatchClick}
        />
        <MenuSelectItem
          isDisabled={!isRadioEnabled}
          label='Radio Guards'
          onClick={onRadioClick}
          showDivider={false}
        />
      </MenuList>
    </Menu>
  )
}
